import './style/emailDisabledMessage.scss';

import React, {PropsWithChildren} from 'react';
import {AwesomeIcon} from '@dvrd/dvr-controls';
import classNames from 'classnames';

interface Props {
    transform?: boolean;
}

export default function EmailDisabledMessage(props: PropsWithChildren<Props>) {
    return (
        <div className={classNames('email-disabled-ornament', props.transform && 'transform')}>
            <AwesomeIcon name='info-circle' className='info-icon'/>
            <p className='email-disabled-info'>
                {props.children}
            </p>
        </div>
    )
}